document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".header__menu-toggle");
  const overlay = document.getElementById("mobileOverlay");
  const originalMenu = document.querySelector(".header__menu-list");
  const mobileMenu = document.querySelector(".header__menu-list--mobile");

  if (originalMenu && mobileMenu) {
    mobileMenu.innerHTML = originalMenu.innerHTML;
  }

  toggleBtn.addEventListener("click", function () {
    overlay.classList.toggle("active");

    if (overlay.classList.contains("active")) {
      toggleBtn.textContent = "Close";
    } else {
      toggleBtn.textContent = "Menu";
    }
  });
});
